import axios from 'axios';
import { message } from 'antd';

// 创建 axios 实例
const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器 - 添加 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const { response } = error;
    
    if (response) {
      const { status, data } = response;
      
      switch (status) {
        case 401:
          message.error('登录已过期，请重新登录');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          break;
        case 403:
          message.error('权限不足');
          break;
        case 404:
          message.error('请求的资源不存在');
          break;
        case 500:
          message.error('服务器错误');
          break;
        default:
          message.error(data?.error?.message || '请求失败');
      }
    } else {
      message.error('网络错误，请检查网络连接');
    }
    
    return Promise.reject(error);
  }
);

// API 方法
export const login = (data) => api.post('/auth/login', data);

export const register = (data) => api.post('/auth/register', data);

export const getCurrentUser = () => api.get('/auth/me');

// AI 内容生成
export const generateTitles = (data) => api.post('/content/titles/generate', data);
export const generateCopywriting = (data) => api.post('/content/copywriting/generate', data);
export const checkForbiddenWords = (data) => api.post('/content/check-forbidden', data);
export const uploadAudio = (data) => api.post('/content/audio/upload', data, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// 内容素材
export const getMaterials = (params) => api.get('/content/materials', { params });
export const createMaterial = (data) => api.post('/content/materials', data);
export const updateMaterial = (id, data) => api.put(`/content/materials/${id}`, data);
export const deleteMaterial = (id) => api.delete(`/content/materials/${id}`);

// 视频
export const getVideos = (params) => api.get('/video/materials', { params });
export const uploadVideo = (data) => api.post('/video/upload', data, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// 账号
export const getAccounts = (params) => api.get('/account/list', { params });
export const getGroups = () => api.get('/account/groups');
export const updateAccountGroup = (id, data) => api.put(`/account/${id}/group`, data);
export const deleteAccount = (id) => api.delete(`/account/${id}`);
export const syncAccount = (id) => api.post(`/account/${id}/sync`);

// 发布任务
export const createPublishTask = (data) => api.post('/publish/tasks', data);
export const getPublishTasks = (params) => api.get('/publish/tasks', { params });
export const getPublishTask = (id) => api.get(`/publish/tasks/${id}`);
export const auditTask = (id, data) => api.put(`/publish/tasks/${id}/audit`, data);
export const cancelTask = (id) => api.put(`/publish/tasks/${id}/cancel`);
export const retryTask = (id) => api.post(`/publish/tasks/${id}/retry`);

// 数据统计
export const getOverview = (params) => api.get('/stats/overview', { params });
export const getVideoStats = (params) => api.get('/stats/videos', { params });
export const getPublishRate = (params) => api.get('/stats/publish-rate', { params });
export const exportStats = (params) => api.get('/stats/export', { params });

export default api;
